let obj = {
    locales: []
}
export default obj